import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { restrictUserAccess } from "services/apis/admin";

export const restrictUser = createAsyncThunk(
  "user/restrict",
  async ({ userId, token }: { userId: any; token: string }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("user_id", userId);
      const { data } = await restrictUserAccess(token, formData);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

interface RestrictUserState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: RestrictUserState = {
  status: "idle",
  error: null,
};

const restrictUserSlice = createSlice({
  name: "restrictUser",
  initialState,
  reducers: {
    resetRestrictUserStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(restrictUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(restrictUser.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(restrictUser.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const { resetRestrictUserStatus } = restrictUserSlice.actions;
export default restrictUserSlice.reducer;
